__turbopack_context__.v({
  "image": "styles-module__PTFkzq__image",
  "selectable": "styles-module__PTFkzq__selectable",
});
